import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { Unit } from '../../../helpers/unit';
import { cancelApproval } from '../../../actions/load';
import LoadCardLeft from './LoadCardLeft';
import { getDisplayDate, getDisplayTime } from '../utils';
import { HARVESTING_PLAN_TYPE_ID, LOGISTIC_PLAN_TYPE_ID } from '../../../constants';
import { Icon } from '../../widgets';
const LoadCardTwo = props => {
	const unit = Unit.getInstance();
	const dispatch = useDispatch();
	const planTypeId = useSelector(state => state.plan.selectedPlanType);
	const weightShortName = useSelector(state => state.user.settings.weightShortName);
	const { load } = props;
	const { load_params = {} } = load;
	const [cancelling, setCancelling] = useState(false);

	const isLogisticPlanSubHarvest = planTypeId === 5 && load.targetPlanTypeId === 4;

	const handleCancel = () => {
		setCancelling(true);

		const params = {
			farm_uuid: load.farmId,
			source_equipment_group_uuid: load.sourceEquipmentGroupId,
			target_equipment_group_uuid: load.targetEquipmentGroupId,
			load_activity_uuid: load.loadActivityId,
			planTypeId
		};

		dispatch(cancelApproval(params, (isSuccess) => {
			!isSuccess && setCancelling(false);
		}));
	};

	const getLabel = (value) => {
		return value ? value.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) : '';
	};

	return <div className="load-card load-card-two mt-2">
		<LoadCardLeft
			load={{ ...load, loadCapacity: load.estimatedLoadCapacity }}
			unit={unit}
			settings={props.settings}
		/>
		<div className="load-card-main">
			<Row className="load-card-header m-0">
				<Col xs={12} className="dateTime-col pl-3">
					{planTypeId === LOGISTIC_PLAN_TYPE_ID && <>
						<div className='d-flex'>

							{load.sourceOffloadGeoShapeName && <div>
								<div>{load.sourceOffloadGeoShapeName}</div>
								<div className='d-flex align-items-center storage-pipe'>
									<div>{load.sourceOffloadStorageLocationName}</div>
									{load.sourcePipe ? <div className='splitter-two'></div> : null}
									<div>{load.sourcePipe}</div>
								</div>
							</div>}
							{load.offloadGeoShapeName &&
								<><div className='d-flex justify-content-center align-items-center dot_arrow-hldr'>
									<div className="dot_arrow_txt"></div>
									<div className="dot_arrow_txt"></div>
									<Icon title=""
										ariaHidden="true"
										className="fa fa-arrow-right mr-1"></Icon>
								</div>
									{load.offloadGeoShapeName && <div>
										<div>{load.offloadGeoShapeName}</div>
										<div className='d-flex align-items-center storage-pipe'>
											<div>{load.offloadStorageLocationName}</div>
											{load.pipe ? <div className='splitter-two'></div> : null}
											<div>{load.pipe}</div>
										</div>
									</div>}
								</>
							}
						</div>
					</>}
				</Col>
				<Col className='col-8'>
					<div className='load-date'>
						<div className="date">{getDisplayDate(load.loadDateTz)}</div>
						<div className="time mb-1">
							{getDisplayTime(load.startDateTz)}
						</div>
						{load.endDateTz ?
							<>
								<span>-</span>
								<div className="time">
									{getDisplayTime(load.endDateTz)}
								</div>
							</> : <></>}
					</div>
				</Col>
				<Col className='col-4'>
					<Button
						size="sm"
						title="Cancel Approval"
						variant="danger"
						disabled={cancelling}
						className="btn-load-queue float-right"
						onClick={handleCancel}
					>
						{cancelling ? "Cancelling..." : "Cancel Approval"}
					</Button>
				</Col>
			</Row>
			<Row className="load-card-detail-1 m-0">
				{!isLogisticPlanSubHarvest ? <>
					<Col xs={4}>
						<div className="label">Implement</div>
						<div className="text">{load.sourceEquipmentGroupName ? load.sourceEquipmentGroupName : "Unknown"}</div>
					</Col>
					{planTypeId === HARVESTING_PLAN_TYPE_ID ?
						<>
							<Col xs={4}>
								<div className="label">Field</div>
								<div className="text">{load.fieldGeoShapeName ? load.fieldGeoShapeName : "N/A"}</div>
							</Col>
							<Col xs={4}>
								<div className="label">Offload Site</div>
								<div className="text">{load.offloadGeoShapeName ? load.offloadGeoShapeName : "N/A"}</div>
							</Col>
							<Col xs={4}>
								<div className="label">Storage</div>
								<div className="text load-storage-pipe">
									{
										load && load.offloadStorageLocationName ?
											<>
												<div>{load.offloadStorageLocationName}</div>
												<div>{load.pipe ? load.pipe : ""}</div>
											</>
											: "N/A"
									}
								</div>
							</Col>
						</> :
						null
					}
				</> : null}
				<Col xs={4}>
					<div className="label">{`Net Weight (${weightShortName})`}</div>
					<div className="text">{unit.toRoundOfWeight(load.loadCapacity)}</div>
				</Col>
				<Col xs={4}>
					<div className="label">{`Gross Weight (${weightShortName})`}</div>
					<div className="text">{unit.toRoundOfWeight(load.loadGrossWeight)}</div>
				</Col>
				<Col xs={4}>
					<div className="label">{`Tare Weight (${weightShortName})`}</div>
					<div className="text">{unit.toRoundOfWeight(load.tareWeight)}</div>
				</Col>
				<Col xs={4}>
					<div className="label">{`Light Weight (${weightShortName})`}</div>
					<div className="text">{unit.toRoundOfWeight(load.lightWeight)}</div>
				</Col>
				{load_params &&
					Object.keys(load_params).map(((e, index) => {
						let value = load_params ?
							(load_params.hasOwnProperty(e) && load_params[e] !== "") ? load_params[e] : "N/A" : "N/A"
						value = Array.isArray(value) ? value.toString() : value;
						return (
							e.showInLoadQueue && <Col className='col-4 pl-3' key={index}>
								{value ? <div className="label">{`${getLabel(e)}`}</div> : null}
								<div className="text">{value}</div>
							</Col>
						)
					}))
				}
			</Row>
		</div>
	</div>;
};

export default LoadCardTwo;